import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex);


const vuexLocal = new VuexPersistence({
    key: 'dimm',
    storage: window.localStorage,
    reducer: (state) => ({
        api_token: state.api_token,
        persist_login: state.persist_login,
        adresses: state.adresses,
    })
})


const vuexSession = new VuexPersistence({
    key: 'dimm',
    storage: window.sessionStorage,
    reducer: (state) => ({
        first_call: state.first_call,
    })
})


export default new Vuex.Store({
    state: {
        //
        Summary: [],
        KTA: [],
        KtaKeywords: [],
        KtaText: [],
        //
        search_keyword: '',
        search_errors: '',
        search_results: [],
        //
        persist_login: false,
        api_token: null,
        query_token: null,
        query_email: null,
        //
        first_call: true,
        //
        adresses: [],
    },
    mutations: {
        setApiToken(state, payload) {
            state.api_token = payload;
        },
        setPersistLogin(state, payload) {
            state.persist_login = payload;
        },
        setQueryToken(state, payload) {
            state.query_token = payload;
        },
        setQueryEmail(state, payload) {
            state.query_email = payload;
        },
        setFirstCall(state, payload) {
            state.first_call = payload;
        },

        setSummary(state, payload) {
            state.Summary = payload;
        },
        setKTA(state, payload) {
            state.KTA = payload;
        },
        setKtaKeywords(state, payload) {
            state.KtaKeywords = payload;
        },
        setKtaText(state, payload) {
            state.KtaText = payload;
        },
        setSearchResults(state, payload) {
            state.search_results = payload;
        },
        setSearchKeyword(state, payload) {
            state.search_keyword = payload;
        },
        setSearchErrors(state, payload) {
            state.search_errors = payload;
        },
        //
        setAdresses(state, payload) {
            state.adresses = payload;
        }
    },

    plugins: [
        vuexLocal.plugin,
        vuexSession.plugin,
    ]
});
